import axios from "axios";

const normalizeBaseUrl = (url) => {
  const cleaned = (url || "").trim().replace(/\/+$/, "");
  if (!cleaned) {
    return "http://localhost:5000/api";
  }
  return cleaned.endsWith("/api") ? cleaned : `${cleaned}/api`;
};

const API = axios.create({
  baseURL: normalizeBaseUrl(process.env.REACT_APP_API_URL)
});

// 🔐 Attach token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 🚨 Handle token expiry
API.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default API;
